import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              marginBottom: 20,
            }}
          >
            <a href="#features">
              <img src="/img/app-store.png" width="200" />
            </a>
            <a href="#features">
              <img src="/img/play-store.png" width="200" />
            </a>
          </div>
          <div className="container text-center">
            <p>&copy; 2024 Todays History.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
